// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div>
    <v-card v-if="selectedObject && showSelectionWindow" transparent style="background: rgba(16, 20, 32, 0.7); backdrop-filter: blur(10px);"> <!-- add commented function here -->
      <v-btn icon style="position: absolute; right: 0" v-on:click.native="unselect()"><v-icon>mdi-close</v-icon></v-btn>
      <v-card-title primary-title>
        <div style="width: 100%">
          <div style="overflow: hidden; text-overflow: ellipsis;">
            <div class="text-h5 primary-title" style="font-weight: bold">{{ title }}</div>
          </div>
        </div>
      </v-card-title>
      <v-card-text :class="{show: !showContent }">
        <template v-for="item in items">
          <v-row style="width: 100%" :key="item.key" :class="item.class" no-gutters>
            <span class="title-name" style="color: #FFFFFF; font-weight:bold; text-align:right; padding-right:5px; opacity:0.7;">{{ item.key }}:</span>
            <span style="font-weight: 500" class="white--text value-name"><span v-html="item.value"></span></span>
          </v-row>
        </template>
        <div style="margin-top: 15px" class="white--text" v-html="wikipediaSummary"></div>
      </v-card-text>
      <v-btn class="show-more-btn" @click.native="showMoreLess">{{ showContentLabel }}
        <img src="@/assets/images/svg/ui/arrow-down.svg" height="20px" :class="{up: !showContent }" style="min-height: 20px"></img>
      </v-btn>
      <v-card-actions style="margin-top: -25px">
        <v-spacer/>
        <template v-for="item in pluginsSelectedInfoExtraGuiComponents">
          <component :is="item" :key="item"></component>
        </template>
      </v-card-actions>
      <v-dialog v-if="!webShareApiSupported || !appMobile" v-model="showShareLinkDialog" width="500px" absolute>
        <v-card style="height: 180px" class="secondary white--text share-link-dialog">
          <v-card-title primary-title>
            <div>
              <h3 class="text-h5 mb-0">Share link</h3>
  <!--            <div v-if="webShareApiSupported || appMobile()">-->
  <!--              <img-->
  <!--                src="@/assets/images/svg/ui/mobile_share.svg"-->
  <!--                @click="shareViaWebShare"-->
  <!--              />-->
  <!--            </div>-->
            </div>
          </v-card-title>
          <v-card-text v-if="!webShareApiSupported || !appMobile" style="width:100%;">
            <v-row style="width: 100%">
              <v-text-field id="link_inputid" v-model="shareLink" label="Link" solo readonly></v-text-field>
              <v-btn @click.native.stop="copyLink">Copy</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
  <!--    <div class="star-options" v-if="$store.state.showSelectedInfoButtons" style="position: absolute; right: -2px; bottom: -60px;">-->
  <!--      <v-btn class="star-btn" v-if="showPointToButton && typeof selectedObject.registry !== 'undefined' && (!webShareApiSupported && !appMobile)" fab small color="transparent" @click.native="showShareLinkDialog = !showShareLinkDialog">-->
  <!--        <img src="@/assets/images/svg/ui/ic_share.svg" height="38px" style="min-height: 38px"></img>-->
  <!--      </v-btn>-->
  <!--      <v-btn class="star-btn" v-if="showPointToButton && typeof selectedObject.registry !== 'undefined' && (appMobile && appVersion)" fab small color="transparent" @click.native="saveStarsMobile">-->
  <!--        <img src="@/assets/images/svg/ui/save.svg" style="margin-top: 0"></img>-->
  <!--      </v-btn>-->
  <!--      <v-btn class="star-btn" v-if="showPointToButton && typeof selectedObject.registry !== 'undefined' && (webShareApiSupported || appMobile)" fab small color="transparent" @click.native="shareViaWebShare">-->
  <!--        <img src="@/assets/images/svg/ui/ic_share.svg" height="38px" style="min-height: 38px;margin-top: 0;"></img>-->
  <!--      </v-btn>-->
  <!--      <v-btn class="star-btn" v-if="showPointToButton" fab small color="transparent" @mousedown="zoomOutButtonClicked()">-->
  <!--        <img :class="{bt_disabled: !zoomOutButtonEnabled, mobileZoomTo: appMobile}" src="@/assets/images/svg/ui/remove_circle_outline.svg" height="38px" style="min-height: 38px"></img>-->
  <!--      </v-btn>-->
  <!--      <v-btn class="star-btn" v-if="showPointToButton" fab small color="transparent" @mousedown="zoomInButtonClicked()">-->
  <!--        <img :class="{bt_disabled: !zoomInButtonEnabled, mobileZoomOut: appMobile}" src="@/assets/images/svg/ui/add_circle_outline.svg" height="38px" style="min-height: 38px"></img>-->
  <!--      </v-btn>-->
  <!--      <v-btn class="star-btn" v-if="showPointToButton && (!webShareApiSupported && !appMobile)" fab small color="transparent" v-on:click.native="lockToSelection()" style="margin-right: 0">-->
  <!--        <img src="@/assets/images/svg/ui/point_to.svg" height="38px" style="min-height: 38px"></img>-->
  <!--      </v-btn>-->
  <!--    </div>-->
      <v-snackbar bottom left :timeout="2000" v-model="copied" color="secondary" >
        Link copied
      </v-snackbar>
    </v-card>
    <selected-object-buttons-mobile></selected-object-buttons-mobile>
  </div>
</template>

<script>

import Moment from 'moment'
import swh from '@/assets/sw_helpers.js'
import SelectedObjectButtonsMobile from '@/components/selected-object-buttons-mobile.vue'
// import selectedButtons from '@/components/selected-object-buttons.vue'

export default {
  components: { SelectedObjectButtonsMobile },
  // components: { selectedButtons },
  data: function () {
    return {
      showMinorNames: false,
      wikipediaData: undefined,
      shareLink: undefined,
      showShareLinkDialog: false,
      copied: false,
      checkApp: false,
      checkAppVersion: false,
      showContent: 'Show More',
      zoomValue: 280,
      zoomMobileValue: 150,
      windowWidth: window.innerWidth,
      items: []
    }
  },
  computed: {
    appMobile: function () {
      var app = swh.checkApp()
      if (app) {
        return true
      } else {
        return false
      }
    },
    appVersion: function () {
      var version = swh.checkAppVersion()
      if (version) {
        return true
      } else {
        return false
      }
    },
    webShareApiSupported: function () {
      if (navigator.share) {
        return navigator.share
      } else {
        return false
      }
    },
    // Unset comment for prod
    showSelectionWindow: function () {
      return this.$store.state.stel && this.$store.state.stel.show_selection_window
    },
    selectedObject: function () {
      return this.$store.state.selectedObject
    },
    stelSelectionId: function () {
      return this.$store.state.stel && this.$store.state.stel.selection ? this.$store.state.stel.selection : undefined
    },
    title: function () {
      return this.selectedObject ? this.otherNames[0] : 'Selection'
    },
    otherNames: function () {
      if ('registry' in this.selectedObject) {
        return [this.selectedObject.registry.name]
      }

      return this.selectedObject ? swh.namesForSkySource(this.selectedObject, 26) : undefined
    },
    otherNames1to7: function () {
      return this.otherNames.slice(1, 8)
    },
    otherNames8andMore: function () {
      return this.showMinorNames ? this.otherNames.slice(8) : []
    },
    wikipediaSummary: function () {
      if (!this.wikipediaData) return ''
      const page = this.wikipediaData.query.pages[Object.keys(this.wikipediaData.query.pages)[0]]
      if (!page || !page.extract) return ''
      const wl = '<b><a style="color: #62d1df;" target="_blank" rel="noopener" href="' + this.wikipediaLink + '">wikipedia</a></b></i>'
      return page.extract.replace(/<p>/g, '').replace(/<\/p>/g, '') + '<span class="grey--text text-caption" style="margin-left:auto; margin-right:0;"><i>&nbsp; ' + this.$t('more on {0}', [wl]) + '</span>'
    },
    wikipediaLink: function () {
      const page = this.wikipediaData.query.pages[Object.keys(this.wikipediaData.query.pages)[0]]
      if (!page || !page.extract) return ''
      return 'https://en.wikipedia.org/wiki/' + page.title
    },
    type: function () {
      if (!this.selectedObject) return this.$t('Unknown')
      let morpho = ''
      if (this.selectedObject.model_data && this.selectedObject.model_data.morpho) {
        morpho = swh.nameForGalaxyMorpho(this.selectedObject.model_data.morpho)
        if (morpho) {
          morpho = morpho + ' '
        }
      }
      return morpho + swh.nameForSkySourceType(this.selectedObject.types[0])
    },
    icon: function () {
      return swh.iconForSkySource(this.selectedObject)
    },
    showPointToButton: function () {
      if (!this.$store.state.stel.lock) return true
      if (this.$store.state.stel.lock === this.$store.state.stel.selection ||
        this.$store.state.stel.lock !== this.$store.state.stel.selection) return true
      return false
    },
    zoomInButtonEnabled: function () {
      if (!this.$store.state.stel.lock || !this.selectedObject) return false
      return true
    },
    zoomOutButtonEnabled: function () {
      if (!this.$store.state.stel.lock || !this.selectedObject) return false
      return true
    },
    extraButtons: function () {
      return swh.selectedObjectExtraButtons
    },
    pluginsSelectedInfoExtraGuiComponents: function () {
      let res = []
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.selectedInfoExtraGuiComponents) {
          res = res.concat(plugin.selectedInfoExtraGuiComponents)
        }
      }
      return res
    },
    showContentLabel: function () {
      return this.showContent ? this.$t('Show More') : this.$t('Show Less')
    }
  },
  watch: {
    selectedObject: function (s, oldObject) {
      this.showMinorNames = false
      this.wikipediaData = undefined
      if (!s) {
        if (this.timer) clearInterval(this.timer)
        this.timer = undefined
        return
      }
      var that = this
      const isSameStar = s && s.registry && oldObject && oldObject.registry && s.registry.registration_number === oldObject.registry.registration_number
      that.items = that.computeItems(isSameStar)
      if (that.timer) clearInterval(that.timer)
      // that.timer = setInterval(() => { that.items = that.computeItems() }, 1000)

      /*
      swh.getSkySourceSummaryFromWikipedia(s).then(data => {
        that.wikipediaData = data
      }, reason => { })
      */
    },
    stelSelectionId: function (s) {
      this.updateSelectedObject(s)
    },
    showShareLinkDialog: function (b) {
      this.shareLink = swh.getShareLink(this)
    }
  },
  methods: {
    updateSelectedObject (s) {
      if (!this.$stel.core.selection) {
        this.$store.commit('setSelectedObject', 0)
        return
      }
      swh.sweObj2SkySource(this.$stel.core.selection, this.$store).then(res => {
        this.$store.commit('setSelectedObject', res)
      }, err => {
        console.log("Couldn't find info for object " + s + ':' + err)
        this.$store.commit('setSelectedObject', 0)
      })
    },
    onResizeWidth: function () {
      this.windowWidth = window.innerWidth
      return this.windowWidth
    },
    saveStarsMobile: async function () {
      if (this.appVersion) {
        try {
          var registryNumber = this.selectedObject.registry.registration_number
          const apiData = await fetch(process.env.VUE_APP_NOCTUASKY_API_SERVER + '/api/v1/skysources/?q=' + registryNumber)
          if (!apiData.ok) {
            throw new Error('Error with API response')
          }
          const data = await apiData.json()
          window.MessageInvoker.postMessage(JSON.stringify({
            type: 'save',
            data: {
              interest: 1,
              match: data[0].match,
              model_data: {
                Bmag: data[0].model_data.Bmag,
                Imag: data[0].model_data.Imag,
                Rmag: data[0].model_data.Rmag,
                Umag: data[0].model_data.Umag,
                Vmag: data[0].model_data.Vmag,
                ra: data[0].model_data.ra,
                de: data[0].model_data.de,
                pm_ra: data[0].model_data.pm_ra,
                pm_de: data[0].model_data.pm_de,
                plx: data[0].model_data.plx,
                rv: data[0].model_data.rv,
                spect_t: data[0].model_data.spect_t
              },
              model: data[0].model,
              components: data[0].components[0],
              registry: {
                registration_number: registryNumber,
                name: data[0].registry.name,
                registered_at: data[0].registry.registered_at,
                lat: data[0].registry.lat,
                lon: data[0].registry.lon,
                distance: this.computeItems()[2].value,
                ra: this.computeItems()[3].value,
                dec: this.computeItems()[4].value,
                az: this.computeItems()[5].value,
                alt: this.computeItems()[6].value
              },
              types: ['*']
            }
          }))
        } catch (e) {
          console.log(e)
        }
      }
    },
    shareViaWebShare: function () {
      navigator.share({
        title: 'Star Finder Star',
        text: 'Look at this Beautiful Star!',
        url: 'https://star-finder.starregistration.net/' + '?q=' + this.selectedObject.registry.registration_number
      })
    },
    computeItems: function (isSameStar = false) {
      const obj = this.$stel.core.selection
      if (!obj || !this.selectedObject) return []
      const that = this

      const ret = []

      const addAttr = (key, attr, format) => {
        const v = obj.getInfo(attr)
        if (v && !isNaN(v)) {
          ret.push({
            key: key,
            value: format ? format(v) : v.toString()
          })
        }
      }

      if ('registry' in this.selectedObject) {
        const registry = this.selectedObject.registry
        ret.push({
          key: that.$t('Registration Number'),
          value: registry.registration_number
        })

        if (!isSameStar) {
          this.zoomPicker()
        }
      }

      addAttr(that.$t('Magnitude'), 'vmag', this.formatMagnitude)// magnitude for zoom
      addAttr(that.$t('Distance'), 'distance', this.formatDistance)
      const formatInt = function (num, padLen) {
        const pad = new Array(1 + padLen).join('0')
        return (pad + num).slice(-pad.length)
      }
      const formatRA = function (a) {
        const raf = that.getFormatted('lon', that.$stel.a2tf(a, 1))
        if (that.appVersion && that.appMobile) {
          return formatInt(raf.hours, 2) + 'h' + ' ' + formatInt(raf.minutes, 2) + 'm' + ' ' + formatInt(raf.seconds, 2) + '.' + raf.fraction + 's'
        } else {
          return '<div class="radecVal">' + formatInt(raf.hours, 2) + '<span class="radecUnit">h</span>&nbsp;</div><div class="radecVal">' + formatInt(raf.minutes, 2) + '<span class="radecUnit">m</span></div><div class="radecVal">' + formatInt(raf.seconds, 2) + '.' + raf.fraction + '<span class="radecUnit">s</span></div>'
        }
      }
      const formatAz = function (a) {
        const raf = that.$stel.a2af(a, 1)
        if (that.appVersion && that.appMobile) {
          return formatInt(raf.degrees < 0 ? raf.degrees + 180 : raf.degrees, 3) + '°' + ' ' + formatInt(raf.arcminutes, 2) + '\'' + ' ' + formatInt(raf.arcseconds, 2) + '.' + raf.fraction + '"'
        } else {
          return '<div class="radecVal">' + formatInt(raf.degrees < 0 ? raf.degrees + 180 : raf.degrees, 3) + '<span class="radecUnit">°</span></div><div class="radecVal">' + formatInt(raf.arcminutes, 2) + '<span class="radecUnit">\'</span></div><div class="radecVal">' + formatInt(raf.arcseconds, 2) + '.' + raf.fraction + '<span class="radecUnit">"</span></div>'
        }
      }
      const formatDec = function (a, useFormatted = true) {
        const raf = useFormatted ? that.getFormatted('lat', that.$stel.a2af(a, 1)) : that.$stel.a2af(a, 1)
        if (that.appVersion && that.appMobile) {
          return raf.sign + formatInt(raf.degrees, 2) + '°' + ' ' + formatInt(raf.arcminutes, 2) + '\'' + ' ' + formatInt(raf.arcseconds, 2) + '.' + raf.fraction + '"'
        } else {
          return '<div class="radecVal">' + raf.sign + formatInt(raf.degrees, 2) + '<span class="radecUnit">°</span></div><div class="radecVal">' + formatInt(raf.arcminutes, 2) + '<span class="radecUnit">\'</span></div><div class="radecVal">' + formatInt(raf.arcseconds, 2) + '.' + raf.fraction + '<span class="radecUnit">"</span></div>'
        }
      }
      const posCIRS = this.$stel.convertFrame(this.$stel.core.observer, 'ICRF', 'JNOW', obj.getInfo('radec'))
      const radecCIRS = this.$stel.c2s(posCIRS)
      const raCIRS = this.$stel.anp(radecCIRS[0])
      const decCIRS = this.$stel.anpm(radecCIRS[1])

      if (this.appVersion && this.appMobile) {
        ret.push({
          key: that.$t('Ra'),
          class: that.$t('ra'),
          value: formatRA(raCIRS)
        })
        ret.push({
          key: that.$t('Dec'),
          class: that.$t('dec'),
          value: formatDec(decCIRS)
        })
        ret.push({
          key: that.$t('Ra/Dec'),
          value: formatRA(raCIRS) + '&nbsp;&nbsp;/&nbsp;&nbsp;' + formatDec(decCIRS)
        })
      } else {
        ret.push({
          key: that.$t('Ra/Dec'),
          value: formatRA(raCIRS) + '&nbsp;&nbsp;&nbsp;' + formatDec(decCIRS)
        })
      }
      const azalt = this.$stel.c2s(this.$stel.convertFrame(this.$stel.core.observer, 'ICRF', 'OBSERVED', obj.getInfo('radec')))
      const az = this.$stel.anp(azalt[0])
      const alt = this.$stel.anpm(azalt[1])
      if (this.appVersion && this.appMobile) {
        ret.push({
          key: that.$t('Az'),
          class: that.$t('az'),
          value: formatAz(az)
        })
        ret.push({
          key: that.$t('Alt'),
          class: that.$t('alt'),
          value: formatDec(alt, false)
        })
        ret.push({
          key: that.$t('Az/Alt'),
          value: formatAz(az) + '&nbsp;&nbsp;/&nbsp;&nbsp;' + formatDec(alt, false)
        })
      } else {
        ret.push({
          key: that.$t('Az/Alt'),
          value: formatAz(az) + '&nbsp;&nbsp;&nbsp;' + formatDec(alt, false)
        })
      }

      this.$stel.core.constellations.custom_constellation = this.selectedObject.registry.custom_constellation === null ? 'NaN' : this.selectedObject.registry.custom_constellation
      return ret
    },

    getFormatted (field, defaultValue) {
      if (!('registry' in this.selectedObject)) {
        return defaultValue
      }
      const registry = this.selectedObject.registry

      if (field === 'lat') {
        return this.latToDec(registry[field])
      }

      if (field === 'lon') {
        return this.lngToRa(registry[field])
      }

      return defaultValue
    },

    latToDec: function (latitude) {
      const sign = latitude >= 0 ? '+' : '-'
      latitude = Math.abs(latitude)
      var DEC = Math.floor(latitude).toString() + '° '
      latitude = (latitude - Math.floor(latitude)) * 60
      DEC += Math.floor(latitude).toString() + '\' '
      latitude = (latitude - Math.floor(latitude)) * 60
      DEC += latitude.toFixed(1) + '"'

      const parts = DEC.split(/ /g)
      const degrees = parseInt(parts[0])

      return {
        sign: sign,
        degrees: Math.abs(degrees),
        arcminutes: parseInt(parts[1]),
        arcseconds: parseInt(parts[2].split('.')[0]),
        fraction: parseInt(parts[2].split('.')[1])
      }
    },

    lngToRa: function (longitude) {
      longitude = (-longitude + 180) / 15
      var RA = Math.floor(longitude).toString() + 'h '
      longitude = (longitude - Math.floor(longitude)) * 60
      RA += Math.floor(longitude).toString() + 'm '
      longitude = (longitude - Math.floor(longitude)) * 60
      RA += Math.floor(longitude).toFixed(1) + 's'

      const parts = RA.split(/ /g)

      return {
        hours: parseInt(parts[0]),
        minutes: parseInt(parts[1]),
        seconds: parseInt(parts[2].split('.')[0]),
        fraction: parseInt(parts[2].split('.')[1])
      }
    },

    formatPhase: function (v) {
      return (v * 100).toFixed(0) + '%'
    },
    formatMagnitude: function (v) {
      if (!v) {
        return 'Unknown'
      }
      return v.toFixed(2)
    },
    formatDistance: function (d) {
      // d is in AU
      if (!d) {
        return 'NAN'
      }
      const ly = d * swh.astroConstants.ERFA_AULT / swh.astroConstants.ERFA_DAYSEC / swh.astroConstants.ERFA_DJY
      if (ly >= 0.1) {
        return ly.toFixed(2) + ' light years'
        // return ly.toFixed(2) + '<span class="radecUnit"> light years</span>'
      }
      if (d >= 0.1) {
        return d.toFixed(2) + ' AU'
        // return d.toFixed(2) + '<span class="radecUnit"> AU</span>'
      }
      const meter = d * swh.astroConstants.ERFA_DAU
      if (meter >= 1000) {
        return (meter / 1000).toFixed(2) + ' km'
        // return (meter / 1000).toFixed(2) + '<span class="radecUnit"> km</span>'
      }
      return meter.toFixed(2) + ' m'
      // return meter.toFixed(2) + '<span class="radecUnit"> m</span>'
    },
    formatTime: function (jdm) {
      var d = new Date()
      d.setMJD(jdm)
      const utc = new Moment(d)
      utc.utcOffset(this.$store.state.stel.utcoffset)
      return utc.format('HH:mm')
    },
    unselect: function () {
      this.$stel.core.show_selection_window = false
    },
    lockToSelection: function () {
      if (this.$stel.core.selection) {
        this.$stel.pointAndLock(this.$stel.core.selection, 0.5)
        this.zoomPicker()
      }
    },
    zoomInButtonClicked: function () {
      const currentFov = this.$store.state.stel.fov * 180 / Math.PI
      this.$stel.zoomTo(currentFov * 0.3 * Math.PI / 180, 0.4)
      const that = this
      this.zoomTimeout = setTimeout(_ => { that.zoomInButtonClicked() }, 300)
      if (this.$stel.pointAndLock(this.$stel.core.selection)) {
        this.zoomTimeout = setTimeout(_ => { that.zoomInButtonClicked() }, 300)
      }
    },
    zoomPicker: function () {
      if (this.onResizeWidth() >= 600) {
        this.$stel.zoomTo(this.zoomValue * 0.3 * Math.PI / 180, 0.4)
      } else {
        this.$stel.zoomTo(this.zoomMobileValue * 0.3 * Math.PI / 180, 0.4)
      }
    },
    zoomOutButtonClicked: function () {
      const currentFov = this.$store.state.stel.fov * 180 / Math.PI
      this.$stel.zoomTo(currentFov * 3 * Math.PI / 180, 0.6)
      const that = this
      this.zoomTimeout = setTimeout(_ => { that.zoomOutButtonClicked() }, 200)
      if (this.$stel.pointAndLock(this.$stel.core.selection)) {
        this.zoomTimeout = setTimeout(_ => { that.zoomOutButtonClicked() }, 200)
      }
    },
    stopZoom: function () {
      if (this.zoomTimeout) {
        clearTimeout(this.zoomTimeout)
        this.zoomTimeout = undefined
      }
    },
    extraButtonClicked: function (btn) {
      btn.callback()
    },
    copyLink: function () {
      const input = document.querySelector('#link_inputid')
      input.focus()
      input.select()
      this.copied = document.execCommand('copy')
      window.getSelection().removeAllRanges()
      this.showShareLinkDialog = false
    },
    showMoreLess: function () {
      this.showContent = !this.showContent
    }
  },
  mounted: function () {
    const that = this
    that.items = that.computeItems()
    window.addEventListener('mouseup', function (event) {
      that.stopZoom()
    })
  },
  created () {
    if (this.stelSelectionId) {
      this.updateSelectedObject(this.stelSelectionId)
    }
  }
}
</script>
<style scoped lang="scss">
.v-dialog .v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  padding: 0 16px !important;
  font-family: Proxima_Bold !important;
}
.star-btn{
  margin: 6px 2px;
}

@media screen and (max-width: 599px) {
  .v-card__title {
    padding: 0px 15px;
  }
  .get-click.v-sheet.v-card {
    padding: 10px;
  }
  .v-card__actions {
    padding: 0;
  }
  .v-dialog > .v-card > .v-card__text {
    padding: 0 24px 5px;
  }
  .star-btn{
    margin: 12px 2px;
  }
}
.primary-title{
  font-size: 20px;
  font-family: Proxima_Bold;
}
.title-name, .value-name{
  font-family: Proxima_Bold;
  font-size: 14px;
  line-height: 30px;
}
.share-link-dialog{
  h3, input{
    font-family: Proxima_Regular !important;
  }
}
</style>
<style lang="scss">

.radecVal {
  display: inline-block;
  font-family: monospace;
  padding-right: 2px;
  font-size: 13px;
  font-weight: bold;
}

.radecUnit {
  color: #ffffff;
  font-weight: bold;
}
.v-card{
  position: absolute;
  max-width: 440px;
  width: 100%;
  top: 70px;
  min-height: 100px;
  @media screen and (max-width: 499px){
    top: 60px;
  }
}

.v-application .text-h5 {
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding: 15px 0;
  @media screen and (max-width: 500px){
    padding: 10px 0;
  }
  @media screen and (max-width: 375px){
    max-width: 220px;
  }
}

.get-click.v-sheet.v-card {
  left: 150px !important;
  margin: 0 !important;
  top: 130px !important;
  padding: 24px;
  .row {
    line-height:2.5;
  }
  @media screen and (max-width: 1299px){
    left: 50px !important;
  }
}
@media screen and (max-width: 599px){
  .get-click.v-sheet.v-card{
    left: 0% !important;
    top: 70px !important;
    max-width: calc(100vw - 40px) !important;
    width: 100% !important;
    margin-left: 20px !important;
  }
  .star-options{
    display: flex;
    flex-direction: column-reverse;
    bottom: -350px !important;
  }
  .mobileZoomTo, .mobileZoomOut{
    height: 55px;
  }
  .v-card__text{
    .row{
      height: 27px;
    }
    &.show{
      height: 140px;
    }
  }
}
.v-text-field.v-text-field--enclosed .v-text-field__details{
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0;
  height: 0;
}
.v-btn--fab.v-size--small{
  width: 38px;
  height: 38px;
}
.v-btn:not(.v-btn--round) {
  &.v-size--default {
    &.show-more-btn {
      display: none;
    }
  }
}
.v-card__text{
  @media screen and (max-width: 499px) {
    height: 0;
    padding-bottom: 0;
    overflow: hidden;
    transition: height 0.5s;
    &.show {
      height: 150px;
    }
  }
}
.v-btn:not(.v-btn--round){
  &.v-size--default{
    &.show-more-btn {
      @media screen and (max-width: 499px) {
        display: block;
        padding: 0 !important;
        background-color: unset !important;
        box-shadow: unset;
        backdrop-filter: unset !important;
        margin: 5px auto 30px;
        span {
          display: flex;
          flex-direction: column;
        }
        img {
          &.up {
            transform: rotate(180deg);
          }
        }
        &:before {
          opacity: 0;
        }
      }
    }
  }
}
.az,.ra,.dec,.alt{
  display: none;
}
@media (orientation: landscape) and (max-width:499px){
  .v-btn:not(.v-btn--round).v-size--default.show-more-btn{
    margin-bottom: 10px;
    margin-top: 0px;
  }
  .mobileCss{
    margin-top: 0 !important;
    //.gyroscope-container{
    //  display: none;
    //}
  }
  .get-click.v-sheet.v-card{
    left: 0% !important;
    top: 70px !important;
    max-width: calc(100vw - 40px) !important;
    width: 100% !important;
    margin-left: 20px !important;
  }
  .mobile-select{
    .star-options{
      display: flex;
      flex-direction: column-reverse;
      bottom: 100px !important;
    }
  }
  .mobileZoomTo, .mobileZoomOut{
    height: 55px;
  }
  .bottom-button{
    &.mobile{
      display: none;
    }
  }
  .v-card__title{
    padding: 5px 16px;
  }
  .v-card__text{
    .row{
      height: 27px;
    }
    &.show{
      height: 140px;
    }
  }
  .v-application .text-h5{
    padding: 5px 0;
    max-width: 220px;
    font-size: 1.4rem !important;
    line-height: 1.8rem;
  }
  .v-card{
    top: 80px;
    max-width: 300px;
  }
}
</style>
